import { put, takeLatest, call } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import UrlHelper from 'helpers/url'
import * as ApiRouter from 'constants/apiRouting'
import NoticeHelper from 'helpers/notice'
import { SHOW_NOTICE } from '../notice'
import {
  FETCH_SITE_LIST,
  SUCCESS_SITE_LIST,
  FAILURE_SITE_LIST,
  SET_SITE_LIST_LOADER,
  FETCH_LOCUS_GROUP_LIST,
  SUCCESS_LOCUS_GROUP_LIST,
  FAILURE_LOCUS_GROUP_LIST,
  SET_LOCUS_GROUP_LIST_LOADER,
  FETCH_LOCUS_LIST,
  SUCCESS_LOCUS_LIST,
  FAILURE_LOCUS_LIST,
  SET_LOCUS_LIST_LOADER,
  FETCH_SENSOR_LIST,
  FETCH_SENSOR_LIST_SUCCESS,
  FETCH_SENSOR_LIST_FAILURE,
  FETCH_DB_LOGBOOK_EVENT_LIST,
  SUCCESS_DB_LOGBOOK_EVENT_LIST,
  FAILURE_DB_LOGBOOK_EVENT_LIST,
  FETCH_PRODUCTION_DATA,
  SUCCESS_PRODUCTION_DATA,
  FAILURE_PRODUCTION_DATA,
  FETCH_ENVIRONMENT_DATA,
  SUCCESS_ENVIRONMENT_DATA,
  FAILURE_ENVIRONMENT_DATA,
  FETCH_LOGBOOK_DATA,
  SUCCESS_LOGBOOK_DATA,
  FAILURE_LOGBOOK_DATA,
  EXPORT_TO_CSV,
} from './reducer'

function* fetchSiteList({ payload: { params } }) {
  try {
    yield put({ type: SET_SITE_LIST_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(ApiRouter.ACTIVE_SITES, params),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_SITE_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_SITE_LIST })
    }

    yield put({ type: SET_SITE_LIST_LOADER, payload: false })
  } catch (error) {
    console.log('DATA BROWSER FAILED ', error)
  }
}

function* fetchLocusGroupList(action) {
  try {
    yield put({ type: SET_LOCUS_GROUP_LIST_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.LOCUS_GROUPS}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_LOCUS_GROUP_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_LOCUS_GROUP_LIST })
    }

    yield put({ type: SET_LOCUS_GROUP_LIST_LOADER, payload: false })
  } catch (error) {
    console.log('DATA BROWSER FAILED ', error)
  }
}

function* fetchLocusList(action) {
  try {
    yield put({ type: SET_LOCUS_LIST_LOADER, payload: true })

    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.LOCUS_LIST}${UrlHelper.getPsfsQuery(
        action.payload,
      )}`,
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: SUCCESS_LOCUS_LIST,
        payload: response,
      })
    } else {
      yield put({ type: FAILURE_LOCUS_LIST })
    }

    yield put({ type: SET_LOCUS_LIST_LOADER, payload: false })
  } catch (error) {
    console.log('DATA BROWSER FAILED ', error)
  }
}

function* fetchSensorList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRouter.DB_SENSORS, action.payload),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({
        type: FETCH_SENSOR_LIST_SUCCESS,
        payload: response,
      })
    } else {
      yield put({ type: FETCH_SENSOR_LIST_FAILURE })
    }
  } catch (error) {
    console.log('DATA BROWSER FAILED ', error)
  }
}

function* fetchLogbookEventList(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        ApiRouter.DB_LOGBOOK_EVENT_LIST,
        action.payload,
      ),
    })

    if (!response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_DB_LOGBOOK_EVENT_LIST, payload: response })
    } else {
      yield put({ type: FAILURE_DB_LOGBOOK_EVENT_LIST })
    }
  } catch (error) {
    console.log('FETCH DATA BROWSER LOGBOOK EVENT LIST FAILURE ', error)
  }
}

function* fetchProductionData(action) {
  const { type, params } = action.payload
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        `${ApiRouter.DB_PRODUCTION_AND_HEALTH_DATA}${type}`,
        params,
      ),
    })

    if (response && !response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_PRODUCTION_DATA, payload: response })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.message),
        })
      }

      yield put({ type: FAILURE_PRODUCTION_DATA, error: response.errors })
    }
  } catch (error) {
    console.log('FETCH PRODUCTION DATA FAILED ', error)
  }
}

function* fetchEnvironmentData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(
        ApiRouter.DB_ENVIRONMENT_DATA,
        action.payload,
      ),
    })

    if (response && !response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_ENVIRONMENT_DATA, payload: response })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.message),
        })
      }

      yield put({ type: FAILURE_ENVIRONMENT_DATA, error: response.errors })
    }
  } catch (error) {
    console.log('FETCH ENVIRONMENT DATA FAILED ', error)
  }
}

function* fetchLogbookData(action) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.createQuery(ApiRouter.DB_LOGBOOK_DATA, action.payload),
    })

    if (response && !response.hasOwnProperty('error')) {
      yield put({ type: SUCCESS_LOGBOOK_DATA, payload: response })
    } else {
      if (response.message && response.message !== '') {
        yield put({
          type: SHOW_NOTICE,
          notice: NoticeHelper.createErrorObj(response.message),
        })
      }

      yield put({ type: FAILURE_LOGBOOK_DATA, error: response.errors })
    }
  } catch (error) {
    console.log('FETCH LOGBOOK DATA FAILED ', error)
  }
}

function* exportToCsv({ payload, promise }) {
  try {
    const { data, headers } = yield call(
      fetchFromAPI,
      {
        headers: getDefaultAutorizedHeaders(),
        partUrl: UrlHelper.createQuery(ApiRouter.DB_EXPORT_CSV_DATA, payload),
      },
      ['data', 'headers'],
    )

    if (data.hasOwnProperty('error')) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(data.message),
      })

      return yield call(promise.resolve)
    }

    if (
      !headers.hasOwnProperty('content-type') ||
      !headers.hasOwnProperty('content-disposition')
    ) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj('File cannot be downloaded'),
      })

      return yield call(promise.resolve)
    }

    const type = headers['content-type'].toLowerCase().replace(' ', '')
    const [, filename] =
      headers['content-disposition'].match(/filename="([^"]+)"/i) || []

    if (!type || !filename) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj('File cannot be downloaded'),
      })

      return yield call(promise.resolve)
    }

    const csvContent = new Blob([data], { type })
    const link = document.createElement('a')
    link.download = filename
    link.href = URL.createObjectURL(csvContent)
    link.click()
    URL.revokeObjectURL(link.href)

    yield call(promise.resolve)
  } catch (error) {
    console.log('EXPORT DATA FAILED ', error)

    return promise.resolve()
  }
}

function* dataBrowserSaga() {
  yield takeLatest(FETCH_SITE_LIST, fetchSiteList)
  yield takeLatest(FETCH_LOCUS_GROUP_LIST, fetchLocusGroupList)
  yield takeLatest(FETCH_LOCUS_LIST, fetchLocusList)
  yield takeLatest(FETCH_DB_LOGBOOK_EVENT_LIST, fetchLogbookEventList)
  yield takeLatest(FETCH_PRODUCTION_DATA, fetchProductionData)
  yield takeLatest(FETCH_ENVIRONMENT_DATA, fetchEnvironmentData)
  yield takeLatest(FETCH_LOGBOOK_DATA, fetchLogbookData)
  yield takeLatest(EXPORT_TO_CSV, exportToCsv)
  yield takeLatest(FETCH_SENSOR_LIST, fetchSensorList)
}

export default dataBrowserSaga
